module.exports = __webpack_public_path__ + "static/img/chanta (3).b158554.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (3).jpg
// module id = zUXA
// module chunks = 0